import { useEffect } from 'react';
import { HeadWrapper, Wrapper, Head, Title } from './employees-page.styles';
import { Button } from '@vtbhome/juicyfront';
import { ArrowsChevronLeft } from '@vtbhome/juicyfront/indexIcon';
import { ModalEmployeeListItemMoreInfo } from '@entities/employee/employee-list-item-more-info/ui/modal-employee-list-item-more-info';
import { useUsersListSharedQuery } from '@entities/user/libs/hooks/use-users-list-shared-query/use-users-list-shared-query';
import { ListEmployees } from '@widgets/list-employees/ui/list-employees';
import { useHistory } from 'react-router-dom';
import { MODAL_USER_KEY } from '@entities/user/config/search-constants';
import { useModalSearch } from '@shared/lib/hooks/use-modal-search/use-modal-search';
import { DEFAULT_USERS_LIST_PARAMETERS } from '@entities/user/config/store-constants';
import { FilterEmployeesList } from '@features/employee/filter-employees-list/ui/filter-employees-list';
import { UsersListManagemntDataRequest } from '@entities/user/api/user-management-types';
import { useSearchParams } from '@shared/lib/hooks/use-search-params/use-search-params';

export const EmployeesPage = () => {
    const history = useHistory();
    const [usersListParameters, setUsersListParameters] =
        useSearchParams<UsersListManagemntDataRequest>(DEFAULT_USERS_LIST_PARAMETERS);
    const [getUsers, getUsersResult] = useUsersListSharedQuery(usersListParameters);
    const { modalSearchValue: modalUserId, setModalSearchValue } = useModalSearch(MODAL_USER_KEY);
    const usersListLength = getUsersResult.isSuccess ? getUsersResult.data?.total || 0 : undefined;

    const handleClickCard = (id: number) => {
        setModalSearchValue(id);
    };

    useEffect(() => {
        getUsers(usersListParameters);
    }, [usersListParameters]);

    return (
        <Wrapper>
            <HeadWrapper>
                <Head>
                    {Boolean(history.length) && (
                        <Button
                            round
                            size='xl'
                            buttonType='secondary'
                            startAdornment={<ArrowsChevronLeft />}
                            onClick={() => history.goBack()}
                        />
                    )}
                    <Title size='h6'>Сотрудники {usersListLength && `(${usersListLength})`}</Title>
                    <FilterEmployeesList
                        usersListParameters={usersListParameters}
                        setUsersListParameters={setUsersListParameters}
                    />
                </Head>
            </HeadWrapper>
            <ListEmployees
                usersListParameters={usersListParameters}
                setUsersListParameters={setUsersListParameters}
                onClickCard={handleClickCard}
            />
            <ModalEmployeeListItemMoreInfo
                isShow={Boolean(modalUserId)}
                userId={modalUserId}
                onClose={() => setModalSearchValue(undefined)}
            />
        </Wrapper>
    );
};
